import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emp-retirement-list-form',
  templateUrl: './emp-retirement-list-form.component.html',
  styleUrls: ['./emp-retirement-list-form.component.css']
})
export class EmpRetirementListFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list-form/emp-retirement-list-form.component.ts